import Windmill from "../Components/Windmill";

export default function(){
    return <Windmill />
}